import api from '../utils/apiUtils';

const API_URL = '/video-content/';

const METADATA_URL = '/metadata/';

export const fetchAllMetadata = async () => {
  try {
    const resp = await api.post(METADATA_URL + 'list-all-metadata', {});
    const metadata = resp.data;
    return metadata;
  } catch (error) {
    console.error('Error fetching metadata:', error);
    throw error;
  }
}
// Fetch all videos
export const fetchVideos = async () => {
  try {
    const resp = await api.post(API_URL + 'list-video-content', {});
    const videos = resp.data
    console.log(videos);
    return videos;
  } catch (error) {
    console.error('Error fetching videos:', error);
    throw error;
  }
};



// Fetch daily video
export const fetchDailyVideo = async () => {
  try {
    const allVideos = await fetchVideos();
    const randomVideo = allVideos[Math.floor(Math.random() * allVideos.length)];
    return randomVideo;
  } catch (error) {
    console.error('Error fetching daily video:', error);
    throw error;
  }
};

// Get video by ID
export const fetchVideoById = async (id) => {
  try {
    const allVideos = await fetchVideos();
    const video = allVideos.find(v => v.id === id);
    if (video) {
      return video;
    } else {
      throw new Error('Video not found');
    }
  } catch (error) {
    console.error('Error fetching video by ID:', error);
    throw error;
  }
};

// Helper function to parse comma-separated values or return array as-is
const parseCommaSeparated = (value) => {
  if (Array.isArray(value)) {
    return value;
  }
  if (typeof value === 'string') {
    return value.split(',').map(item => item.trim()).filter(item => item.length > 0);
  }
  return [];
};

// Filter videos
export const filterVideos = (videos, searchTerm = '', chakraFilter = '', emotionFilter = '', categoryFilter = '') => {
  return new Promise((resolve) => {
    setTimeout(() => {
      let filtered = videos;
      
      if (searchTerm) {
        const term = searchTerm.toLowerCase();
        filtered = filtered.filter(video => {
          const chakras = parseCommaSeparated(video.chakras);
          const emotions = parseCommaSeparated(video.emotions);
          const tags = parseCommaSeparated(video.tags || '');
          
          return video.title.toLowerCase().includes(term) ||
                 video.excerpt.toLowerCase().includes(term) ||
                 video.fullContent.toLowerCase().includes(term) ||
                 chakras.some(chakra => chakra.toLowerCase().includes(term)) ||
                 emotions.some(emotion => emotion.toLowerCase().includes(term)) ||
                 tags.some(tag => tag.toLowerCase().includes(term));
        });
      }
      
      if (chakraFilter) {
        filtered = filtered.filter(video => {
          const chakras = parseCommaSeparated(video.chakras);
          return chakras.includes(chakraFilter);
        });
      }
      
      if (emotionFilter) {
        filtered = filtered.filter(video => {
          const emotions = parseCommaSeparated(video.emotions);
          return emotions.includes(emotionFilter);
        });
      }
      
      if (categoryFilter) {
        filtered = filtered.filter(video => {
          return video.categoryName === categoryFilter;
        });
      }
      
      resolve(filtered);
    }, 400);
  });
};

// Get unique chakras and emotions for filter options
export const getFilterOptions = (videos) => {
  const allChakras = new Set();
  const allEmotions = new Set();
  
  videos.forEach(video => {
    const chakras = parseCommaSeparated(video.chakras);
    const emotions = parseCommaSeparated(video.emotions);
    
    chakras.forEach(chakra => allChakras.add(chakra));
    emotions.forEach(emotion => allEmotions.add(emotion));
  });
  
  return {
    chakras: Array.from(allChakras).sort(),
    emotions: Array.from(allEmotions).sort()
  };
}; 